import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

function IdentityPhotoUploader({ onFileUpload, text }) {
	const [uploadedFile, setUploadedFile] = useState(null);

	const onDrop = useCallback(
		(acceptedFiles) => {
			if (acceptedFiles.length > 0) {
				const selectedFile = acceptedFiles[0];
				setUploadedFile(selectedFile);
				onFileUpload(selectedFile);
			}
		},
		[onFileUpload]
	);

	const { getRootProps, getInputProps } = useDropzone({
		onDrop,
		accept: {
			'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp'],
			'application/pdf': ['.pdf']
		},
		multiple: false,
	});

	const isPdf = uploadedFile?.type === 'application/pdf';

	return (
		<div>
			<div {...getRootProps()} style={dropzoneStyles}>
				<input {...getInputProps()} />
				<p>{text}</p>
				{uploadedFile && (
					<div>
						{isPdf ? (
							<div style={pdfPreviewStyles}>
								<span style={pdfIconStyles}>📄</span>
								<span style={pdfNameStyles}>{uploadedFile.name}</span>
							</div>
						) : (
							<img
								src={URL.createObjectURL(uploadedFile)}
								alt="Visualização da identidade funcional"
								style={imageStyles}
							/>
						)}
					</div>
				)}
			</div>
		</div>
	);
}

const dropzoneStyles = {
	border: "2px dashed #cccccc",
	borderRadius: "4px",
	padding: "20px",
	textAlign: "center",
	cursor: "pointer",
	maxWidth: "40rem",
};

const imageStyles = {
	maxWidth: "100%",
	maxHeight: "200px",
	marginTop: "10px",
};

const pdfPreviewStyles = {
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	marginTop: "10px",
	padding: "15px",
	backgroundColor: "#f5f5f5",
	borderRadius: "8px",
};

const pdfIconStyles = {
	fontSize: "48px",
	marginBottom: "8px",
};

const pdfNameStyles = {
	fontSize: "14px",
	color: "#333",
	wordBreak: "break-all",
	textAlign: "center",
};

export default IdentityPhotoUploader;

